import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // Binding
        this.onChangeBind = this.onChange.bind(this)
        this.onResetBind = this.onReset.bind(this)

        // UI
        this.$form = this.$('form')[0]
        this.$cards = this.$('item')
        // this.$placeholder = this.$('placeholder')[0]
        //this.$resetButton = this.$('reset')[0]
    }

    // ===============
    // Lifecycle
    // ===============
    init() {
        this.bindEvents()
        this.onChange();
    }

    destroy() {
        this.unbindEvents()
    }

    // ===============
    // Events
    // ===============
    bindEvents() {
        this.$form.addEventListener('change', this.onChangeBind)
        // this.$resetButton.addEventListener('click', this.onResetBind)
    }

    unbindEvents() {
        this.$form.removeEventListener('change', this.onChangeBind)
        // this.$resetButton.removeEventListener('click', this.onResetBind)
    }

    // ===============
    // Callbacks
    // ===============
    onChange(e) {
        const form = new FormData(this.$form);
        const selectedType = form.get('type-event')

        this.$cards.forEach($card => {
            const types = $card.dataset.types;
            $card.classList.add('is-hidden');

            requestAnimationFrame(() => {
                if (
                    (selectedType === 'Tout voir' || types.includes(selectedType))
                ) {
                    $card.classList.remove('is-hidden');
                } else {
                    $card.classList.add('is-hidden');
                }
            });
        });
    }

    onReset() {
        // Show all cards
        this.$cards.forEach($card => {
            $card.classList.add('is-hidden');

            requestAnimationFrame(() => {
                $card.classList.remove('is-hidden');
            });
        });


        // Reset form data
        this.$form.reset()
    }
}